var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component } from "vue-property-decorator";
import { ValidationObserver } from 'vee-validate';
import { Notification } from "@/common/services/notificationService";
import { AttachmentsCollection } from "@/common/types/AttachmentsCollection";
import { CorrespondenceState } from "@/common/types/CorrespondenceState";
import LabelControl from '@/common/components/LabelControl.vue';
import TextLabelRow from '@/common/components/TextLabelRow.vue';
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import AttachmentTable from '@/common/components/AttachmentTable.vue';
import CorrespondenceBase from '@/template/views/CorrespondenceBase';
var CorrespondenceView = /** @class */ (function (_super) {
    __extends(CorrespondenceView, _super);
    function CorrespondenceView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.correspondence = {};
        _this.isAnswerPanelVisible = false;
        _this.newMessage = {};
        return _this;
    }
    Object.defineProperty(CorrespondenceView.prototype, "latestMessage", {
        get: function () {
            return this.correspondence ? this.correspondence.latestMessage : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CorrespondenceView.prototype, "attachmentsAreValid", {
        get: function () {
            var _this = this;
            return !this.newMessage.attachments
                || this.newMessage.attachments.every(function (x) { return ((x.name != null && x.name != "" && x.name.length <= _this.attachmentNameMaxLength) && (x.blobUri != null && x.blobUri != "")) || _this.isAttachmentEmpty(x); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CorrespondenceView.prototype, "attachmentsNamesAreUnique", {
        get: function () {
            if (!(this === null || this === void 0 ? void 0 : this.newMessage.attachments) || this.newMessage.attachments.length <= 1)
                return true;
            return new AttachmentsCollection(this.newMessage.attachments).attachmentsNamesAreUnique();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CorrespondenceView.prototype, "attachmentsFileNamesAreUnique", {
        get: function () {
            if (!(this === null || this === void 0 ? void 0 : this.newMessage.attachments) || this.newMessage.attachments.length <= 1)
                return true;
            return new AttachmentsCollection(this.newMessage.attachments).attachmentsFileNamesAreUnique();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CorrespondenceView.prototype, "attachmentNameMaxLength", {
        get: function () {
            return 50;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CorrespondenceView.prototype, "messageMaxLength", {
        get: function () {
            return 6000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CorrespondenceView.prototype, "downloadingPdf", {
        get: function () {
            return this.$store.state.vuexPageModule.downloadingPdf;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_DOWNLOADING_PDF", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CorrespondenceView.prototype, "saving", {
        get: function () {
            return this.$store.state.vuexPageModule.saving;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_SAVING", value);
        },
        enumerable: false,
        configurable: true
    });
    CorrespondenceView.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.confirmMessageKey = "Correspondence.UnsendMessageConfirmation";
                        this.correspondenceRefId = this.$route.params.id;
                        return [4 /*yield*/, this.fetchDataFromApi()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    CorrespondenceView.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.loading == true)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.delay(10)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 0];
                    case 2:
                        this.focusOnFirstTag("h1");
                        return [2 /*return*/];
                }
            });
        });
    };
    CorrespondenceView.prototype.fetchDataFromApi = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, this.entityService.getCorrespondence(this.correspondenceRefId)];
                    case 1:
                        _a.correspondence = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        console.error(e_1);
                        this.correspondence = {};
                        error = this.$t("Correspondence.FetchFailed");
                        Notification.error(this, error);
                        this.routeService.goToCorrespondenceFrontPage();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CorrespondenceView.prototype.send = function () {
        return __awaiter(this, void 0, void 0, function () {
            var obs, isValid, response, error, error, uLStart, uLEnd, lIStart, lIEnd, notificationDurationMs, errorNotificationMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$refs["correspondenceObserver"]];
                    case 1:
                        obs = _a.sent();
                        return [4 /*yield*/, obs.validate()];
                    case 2:
                        isValid = _a.sent();
                        if (!this.validateForm(isValid)) return [3 /*break*/, 6];
                        if (!confirm(this.$i18n.t("Confirmation.SendToStea").toString())) return [3 /*break*/, 5];
                        this.saving = true;
                        this.cleanNewMessageEmptyAttachments();
                        this.newMessage.sentDate = new Date();
                        this.correspondence.messages.splice(0, 0, this.newMessage);
                        this.correspondence.state = this.correspondence.isInformationRequest
                            ? CorrespondenceState.Ready
                            : CorrespondenceState.ReceivedFromWeb;
                        return [4 /*yield*/, this.entityService.sendCorrespondence(this.correspondence)];
                    case 3:
                        response = _a.sent();
                        if (response.ok) {
                            Notification.success(this, this.$t("Correspondence.SendSuccess").toString());
                            this.hideAnswerPanel();
                        }
                        else if (response.status == 403) {
                            error = this.$t("Correspondence.SendFailed");
                            Notification.error(this, error);
                            this.fetchDataFromApi();
                            this.hideAnswerPanel();
                        }
                        else {
                            error = this.$t("Correspondence.SendFailed");
                            Notification.error(this, error);
                        }
                        return [4 /*yield*/, this.recomputeOpenCorrespondences()];
                    case 4:
                        _a.sent();
                        this.saving = false;
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        uLStart = "<ul>";
                        uLEnd = "</ul>";
                        lIStart = "<li>";
                        lIEnd = "</li>";
                        notificationDurationMs = 5000;
                        errorNotificationMessage = this.$t("Correspondence.Validation.NotValid");
                        errorNotificationMessage += uLStart;
                        if (!this.newMessage.message) {
                            errorNotificationMessage += lIStart + this.$t("Correspondence.Validation.Message") + lIEnd;
                        }
                        else if (this.newMessage.message.length > this.messageMaxLength) {
                            errorNotificationMessage += lIStart + this.$t("Correspondence.Message") + " - " + this.$t("Validation.maxlength") + lIEnd;
                        }
                        if (!this.attachmentsAreValid) {
                            errorNotificationMessage += lIStart + this.$t("Correspondence.Validation.Attachments") + lIEnd;
                        }
                        if (!this.attachmentsNamesAreUnique) {
                            notificationDurationMs = 10000;
                            errorNotificationMessage += lIStart + this.$t("Correspondence.Validation.AttachmentsDuplicateName") + lIEnd;
                        }
                        if (!this.attachmentsFileNamesAreUnique) {
                            notificationDurationMs = 10000;
                            errorNotificationMessage += lIStart + this.$t("Correspondence.Validation.AttachmentsDuplicateFileName") + lIEnd;
                        }
                        errorNotificationMessage += uLEnd;
                        Notification.error(this, errorNotificationMessage, null, notificationDurationMs);
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    CorrespondenceView.prototype.cleanNewMessageEmptyAttachments = function () {
        var _this = this;
        this.newMessage.attachments = this.newMessage.attachments.filter(function (x) { return !_this.isAttachmentEmpty(x); });
    };
    CorrespondenceView.prototype.generatePdf = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.downloadingPdf = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.pdfService.generatePdf("Correspondence", this.correspondenceRefId, this.languageCode)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        error = this.$t("PdfError");
                        Notification.error(this, error);
                        console.error(error, e_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.downloadingPdf = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    CorrespondenceView.prototype.showAttachments = function (message) {
        return message.attachments && message.attachments.length > 0;
    };
    CorrespondenceView.prototype.isFromStea = function (message) {
        return message && message.senderId != null;
    };
    CorrespondenceView.prototype.getAttachmentFileName = function (attachment) {
        return attachment.fileNameWithExtension
            ? attachment.fileNameWithExtension
            : attachment.blobUri ? attachment.blobUri.substr(37, attachment.blobUri.length) : null;
    };
    CorrespondenceView.prototype.canBeAnswered = function (index) {
        return index === 0
            && this.correspondence.state === CorrespondenceState.SentToWeb
            && !this.isPastDeadline(this.latestMessage.deadline);
    };
    CorrespondenceView.prototype.showDeadline = function (index) {
        return index === 0 && this.correspondence.state === CorrespondenceState.SentToWeb;
    };
    CorrespondenceView.prototype.showAnswerPanel = function () {
        this.initializeNewMessage();
        this.isAnswerPanelVisible = true;
    };
    CorrespondenceView.prototype.hideAnswerPanel = function () {
        this.isAnswerPanelVisible = false;
        this.initializeNewMessage();
        this.clean();
    };
    CorrespondenceView.prototype.validateForm = function (valid) {
        return valid && this.attachmentsAreValid && this.attachmentsNamesAreUnique && this.attachmentsFileNamesAreUnique;
    };
    CorrespondenceView.prototype.isAttachmentEmpty = function (a) {
        return (a.name == null || a.name == "") && (a.blobUri == null || a.blobUri == "");
    };
    CorrespondenceView.prototype.initializeNewMessage = function () {
        this.newMessage = {
            deadline: this.correspondence.latestMessage.deadline,
            header: this.correspondence.latestMessage.header,
            message: null,
            attachments: []
        };
    };
    CorrespondenceView = __decorate([
        Component({
            name: "CorrespondenceView",
            components: {
                ValidationObserver: ValidationObserver,
                LabelControl: LabelControl,
                TextLabelRow: TextLabelRow,
                TextAreaRow: TextAreaRow,
                AttachmentTable: AttachmentTable
            }
        })
    ], CorrespondenceView);
    return CorrespondenceView;
}(CorrespondenceBase));
export default CorrespondenceView;
